'use client'

import { Spacer, Text } from '@vinted/web-ui'

import { getContentWithThreadId } from '@marketplace-web/help-center/help-center-faq-content-data'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'

import { HelpCenterFaqEntryEmailTrackingEvent } from '@marketplace-web/order-emails/order-emails-tracking-feature'

import HelpCenterFaqEntryTrackingEvent from '../HelpCenterFaqEntryTrackingEvent'

type Props = {
  faqEntryId: number
  title: string | null | undefined
  content: string | null | undefined
  xhrRequest?: boolean
  accessChannel?: string
}

const HelpCenterFaqContent = ({
  faqEntryId,
  title,
  content,
  xhrRequest = false,
  accessChannel,
}: Props) => {
  const { thread_id } = useBrowserNavigation().searchParams

  return (
    <article className="faq__question-answer faq-content faq-content--accordion">
      <HelpCenterFaqEntryTrackingEvent faqEntryId={faqEntryId} accessChannel={accessChannel} />
      <HelpCenterFaqEntryEmailTrackingEvent faqEntryId={faqEntryId} />
      {!xhrRequest && <Spacer />}
      {!!title && <Text as="h1" type={Text.Type.Heading} text={title} />}
      {!!title && <Spacer size={Spacer.Size.Large} />}
      {!!content && (
        <Text
          as="span"
          text={getContentWithThreadId(content, thread_id)}
          width={Text.Width.Parent}
          html
        />
      )}
    </article>
  )
}

export default HelpCenterFaqContent
